import React, { useEffect, useState } from "react";
import YearlyCommonDashboard from "../YearlyCommonDashboard/YearlyCommonDashboard";
import { GetYearlyDividendCalculationReportExportToExcel } from "../../../../Helpers/APIEndPoints/EndPoints";

const DividentCalculationReport = () => {
  return (
    <>
      <YearlyCommonDashboard
        PageName="DividendCalculation"
        ExportToExcelUrl={GetYearlyDividendCalculationReportExportToExcel}
        UploadExcel={false} // true -> Option for UploadExcel, false -> NO Option for UploadExcel
        ExcelImport={""}
        openModal={""}
      />
    </>
  );
};

export default DividentCalculationReport;
